import React from "react";
import T from "prop-types";

export default function Stat({ label, value, labelFontSize }) {
  return (
    <div className="text-center">
      <h2 className="margin-bottom-none" style={{ fontSize: labelFontSize }}>
        {value}
      </h2>
      <p className="lead text-muted" style={{ fontSize: 14 }}>
        <em>{label}</em>
      </p>
    </div>
  );
}

Stat.propTypes = {
  label: T.string,
  value: T.string,
  labelFontSize: T.string
};

Stat.defaultProps = {
  labelFontSize: "24px"
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Stat/Stat.jsx